// Utility to replace hardcoded API URLs
// Import this in components that still use hardcoded URLs

import { API_CONFIG } from "../config/api.config";

export const getApiUrl = (endpoint) => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  return `${API_CONFIG.BASE_URL}${cleanEndpoint}`;
};

export const getAuthUrl = (endpoint) => {
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  return `${API_CONFIG.AUTH_URL}${cleanEndpoint}`;
};

// Direct exports for convenience
export const API_ENDPOINTS = {
  // Auth
  LOGIN: `${API_CONFIG.AUTH_URL}/login`,
  REGISTER: `${API_CONFIG.AUTH_URL}/register`,
  CHECK_USER: `${API_CONFIG.AUTH_URL}/check-user`,

  // Hotels
  HOTELS: `${API_CONFIG.BASE_URL}/hotels`,
  HOTEL_BY_ID: (id) => `${API_CONFIG.BASE_URL}/hotels/${id}`,
  HOTEL_ROOMS: (id) => `${API_CONFIG.BASE_URL}/hotels/${id}/rooms`,
  HOTEL_PHOTOS: (id) => `${API_CONFIG.BASE_URL}/hotel-photos/${id}`,

  // Restaurants
  RESTAURANTS: `${API_CONFIG.BASE_URL}/restaurants`,
  RESTAURANT_BY_ID: (id) => `${API_CONFIG.BASE_URL}/restaurants/${id}`,
  RESTAURANT_TABLES: (id) => `${API_CONFIG.BASE_URL}/restaurants/${id}/tables`,
  RESTAURANT_PHOTOS: (id) => `${API_CONFIG.BASE_URL}/restaurant-photos/${id}`,

  // Bookings
  ROOM_BOOKINGS: `${API_CONFIG.BASE_URL}/room-bookings`,
  ROOM_BOOKING_CREATE: `${API_CONFIG.BASE_URL}/room-bookings/create-with-payment`,
  ROOM_BOOKING_VERIFY: `${API_CONFIG.BASE_URL}/room-bookings/verify-payment-and-create`,
  ROOM_BOOKING_USER: (userId) =>
    `${API_CONFIG.BASE_URL}/room-bookings/user/${userId}`,

  RESTAURANT_BOOKINGS: `${API_CONFIG.BASE_URL}/restaurant-bookings`,
  RESTAURANT_BOOKING_CREATE: `${API_CONFIG.BASE_URL}/restaurant-bookings/create-with-payment`,
  RESTAURANT_BOOKING_VERIFY: `${API_CONFIG.BASE_URL}/restaurant-bookings/verify-payment-and-create`,
  RESTAURANT_BOOKING_USER: (userId) =>
    `${API_CONFIG.BASE_URL}/restaurant-bookings/user/${userId}`,

  // Blog
  BLOG: `${API_CONFIG.BASE_URL}/blog`,
  BLOG_UPLOAD: `${API_CONFIG.BASE_URL}/blog/upload`,
  BLOG_SEARCH: (query) =>
    `${API_CONFIG.BASE_URL}/blog/search?q=${encodeURIComponent(query)}`,

  // Profile
  PROFILE_BASIC: (userId) => `${API_CONFIG.BASE_URL}/profile/basic/${userId}`,
};

export default API_CONFIG;
